import { searchCache, userDocumentSearchCache } from '@/apiCache';
import { UNEXPECTED_CONTENT_TYPE_ERROR } from '@/constants';
import axios from 'axios';
import * as admin from './admin';
import * as articleExclusion from './articleExclusion';
import * as articleShare from './articleShare';
import * as comment from './comment';
import * as contents from './contents';
import * as dashboard from './dashboard';
import * as document from './document';
import * as feedSummary from './feedSummary';
import * as fmea from './fmea';
import * as followList from './followList';
import * as forcedIdeation from './forcedIdeation';
import * as group from './group';
import * as groupMark from './groupMark';
import * as insights from './insights';
import * as keywordRecommendation from './keywordRecommendation';
import * as mark from './mark';
import * as marketSizing from './marketSizing';
import * as organizationTag from './organizationTag';
import * as patentFto from './patentFto';
import * as personalSurveyProfile from './personalSurveyProfile';
import * as relatedArticle from './relatedArticle';
import * as reportSearch from './reportSearch';
import * as search from './search';
import * as shareSurvey from './shareSurvey';
import * as site from './site';
import * as survey from './survey';
import * as team from './team';
import * as teamSearch from './teamSearch';
import * as theme from './theme';
import * as tracking from './tracking';
import * as user from './user';
import * as visasq from './visasq';
import * as webPush from './webPush';

axios.defaults.baseURL = '/api/v1/';
axios.defaults.timeout = 35000;

// マーク/グループマーク/タグ/メモ/コメントなど、検索結果キャッシュに含まれる
// ユーザー起因の可変状態を変更するエンドポイント。
// これらの更新はどの画面から行われたかに関わらず検索結果キャッシュを
// 古くする可能性があるため、レスポンス成功時にキャッシュを丸ごと破棄する。
const SEARCH_CACHE_INVALIDATION_URL_PATTERNS = [
  /^\/?(marks|group_marks|comments)(\/|\?|$)/,
  /\/articles\/\d+\/(tags|memos)(\/|\?|$)/,
];

axios.interceptors.response.use(
  function (response) {
    // ユーザー環境によっては、社内プロキシなどの認証が切れたときに200で
    // エラー画面が返されることがある。Content-TypeがJSONではなくなるので
    // ここで拾って、pcApp.tsでエラー表示とロギングを行う。
    const contentType = response.headers['content-type'];
    if (
      response.status === 200 &&
      !/(text|application)\/json/.test(contentType)
    ) {
      return Promise.reject(new Error(UNEXPECTED_CONTENT_TYPE_ERROR));
    }

    const method = response.config.method?.toLowerCase();
    const url = response.config.url ?? '';
    if (
      method &&
      method !== 'get' &&
      SEARCH_CACHE_INVALIDATION_URL_PATTERNS.some(pattern => pattern.test(url))
    ) {
      searchCache.cleanup();
      userDocumentSearchCache.cleanup();
    }

    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// 新しくモジュールを追加したときは tests/api/index.spec.tsにも追加してください
// APIの重複チェックなどをしてます
const api = {
  ...admin,
  ...articleExclusion,
  ...articleShare,
  ...comment,
  ...contents,
  ...document,
  ...feedSummary,
  ...fmea,
  ...followList,
  ...forcedIdeation,
  ...group,
  ...groupMark,
  ...insights,
  ...keywordRecommendation,
  ...mark,
  ...marketSizing,
  ...organizationTag,
  ...patentFto,
  ...personalSurveyProfile,
  ...relatedArticle,
  ...reportSearch,
  ...search,
  ...site,
  ...team,
  ...teamSearch,
  ...theme,
  ...tracking,
  ...user,
  ...webPush,
  ...survey,
  ...shareSurvey,
  ...dashboard,
  ...visasq,
} as const;
export default api;
